import * as gears from './gears.json'
import * as emojiShock from './emojiShock.json'
import * as sadCloud from './sadCloud.json'

export default {
  GEARS: gears,
  EMOJI_SHOCK: emojiShock,
  SAD_CLOUD: sadCloud,
}



// WEBPACK FOOTER //
// ./src/assets/lottieSources/lottieSourcesMap.js